import loginBanner from "../assets/splitpos-login-banner.webp";
import splitPosLogo from "../assets/splitPosLogo.png";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import { postReqwithoutHeader } from "../utils/ApiClient";
import debounce from "lodash.debounce";
import { EMAIL_REQUIRED_MSG, VALID_EMAIL_MSG } from "../utils/validationmsg";
import SpinnerComponent from "../components/SpinnerComponent";
import { isValidEmail } from "../utils/utils";
const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
  });
  const [formError, setFormError] = useState({
    email: "",
  });
  const location = useLocation();
  const userType = location.state;
  console.log("location", location.state);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    const error = { ...formError };
    switch (name) {
      case "email":
        error.email =
          value === ""
            ? EMAIL_REQUIRED_MSG
            : !isValidEmail(value)
              ? VALID_EMAIL_MSG
              : "";
        break;
      default:
        break;
    }
    setFormError({ ...error });
  };
  const validate = () => {
    let error = true;
    const submitError = { ...formError };
    if (formData.email === "") {
      error = false;
      submitError.email = EMAIL_REQUIRED_MSG;
    } else if (
      !formData.email.match(
        // eslint-disable-next-line
        /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/,
      )
    ) {
      error = false;
      submitError.email = VALID_EMAIL_MSG;
    }
    setFormError({ ...submitError });
    return error;
  };

  const handleSubmit = async (e) => {
    if (validate()) {
      try {
        setLoading(true);
        const url =
          userType === "employee-password"
            ? "web/empForgetPassword"
            : "forgetPassword";
        const result = await postReqwithoutHeader(url, {
          email: formData.email,
        });
        if (result.data.status === 200) {
          setLoading(false);
          toast.success(result?.data?.message, {
            theme: "colored",
            autoClose: 950,
          });
          if (userType === "employee-password") {
            navigate("/emp-login");
          } else {
            navigate("/sign-in");
          }
        } else {
          toast.error(result?.data?.message, {
            theme: "colored",
            autoClose: 950,
          });
        }
      } catch (error) {
        setLoading(false);
        const { response } = error;
        const { data } = response;
        toast.error(data?.message, { theme: "colored", autoClose: 950 });
      }
    }
  };
  const delayCall = debounce(handleSubmit, 1500);

  const handleRedirect = () => {
    if (userType === "employee-password") {
      navigate("/emp-login");
    } else {
      navigate("/sign-in");
    }
  };
  return (
    <section className="login-page-v2">
      <div className="container-fluid">
        <div className="row min-vh-100">
          {/* Left Branding Panel */}
          <div className="col-lg-7 d-none d-lg-flex login-brand-panel">
            <img
              src={loginBanner}
              alt="SplitPOS"
              className="login-banner-image"
            />
          </div>

          {/* Right Form */}
          <div className="col-lg-5 d-flex align-items-center justify-content-center">
            <div className="login-card">
              <div className="text-center mb-4">
                <div className="login-logo-wrapper">
                  <img
                    src={splitPosLogo}
                    alt="SplitPOS"
                    className="login-logo"
                  />
                </div>
                <div className="forgot-icon">
                  <i className="fa fa-lock"></i>
                </div>
                <h2 className="mt-4">Forgot Password?</h2>
                <p className="text-muted">
                  Enter the email address associated with your account.
                </p>
              </div>

              <div className="password-group mb-4">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email address"
                  onChange={handleChange}
                />
                <small className="text-danger">{formError.email}</small>
              </div>
              <div className="row mt-4 g-3">
                <div className="col-6">
                  <button
                    type="button"
                    className="auth-btn auth-btn-cancel"
                    onClick={handleRedirect}
                  >
                    Cancel
                  </button>
                </div>

                <div className="col-6">
                  {loading ? (
                    <button
                      type="button"
                      className="auth-btn auth-btn-submit"
                      disabled
                    >
                      <SpinnerComponent /> Please wait...
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="auth-btn auth-btn-submit"
                      onClick={delayCall}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ForgotPassword;
